export const APPLICANT = 'applicant';
export const CCO = 'cco';
export const CLUSTER_ADMIN = 'cluster-admin';
export const IRB = 'irb';
export const SECRETARY = 'secretary';
export const REVIEWER = 'reviewer';
export const HO_ADMIN = 'ho-admin';

export const DRAFT = 0;
export const SUBMITTED = 1;
export const RE_SUBMITTED = 2;
export const RETURNED = 3;
export const CONFIRMED = 5;
export const FOR_REVIEW = 6;
export const APPROVED = 7;
export const ACKNOWLEDGED = 8;
export const DISAPPROVED = 9;
export const WITHDRAWN = 10;
export const TERMINATED = 11;
export const COMPLETED = 12;
export const EXPIRED = 13;
export const RETURN_FROM_IRB = 17;
export const SUSPEND = 19;
export const NA = 20;
//extra status added
export const REVIEWED = 14;
export const REQUEST_FOR_RETURN = 4;
export const VERIFIED = 15;
export const DISTRIBUTED = 16;
export const REJECT_REQUEST_FOR_RETURN = 18;

export const TAB_STUDY = 'info';
export const TAB_SITE = 'hospital';
export const TAB_COMMENT = 'comment';
export const TAB_AMENDMENT = 'amendment';
export const TAB_REVIEWER_COMMENT = 'reviewerComment';
export const TAB_CONSOLIDATION = 'consolidation';
export const TAB_MEETINGARRANGE = 'meetingArrangement';

export const FOLDER_RECEIVED = 'Received';
export const FOLDER_DRAFT = 'Draft';
export const FOLDER_SENT = 'Sent';
export const FOLDER_RETURNED = 'Returned';
export const FOLDER_APPROVED = 'Approved';
export const FOLDER_ACKNOWLEDGED = 'Acknowledged';
export const FOLDER_ARCHIVED = 'Archived';
export const FOLDER_COMPLETED = 'Completed';
export const FOLDER_EXPIRED = 'Expired';
export const FOLDER_CONFIRMED = 'Confirmed';
export const FOLDER_REVIEWED = 'Reviewed';
export const FOLDER_FOR_REVIEW = 'For Review';
export const FOLDER_VERIFIED = 'Verified';
export const FOLDER_DISTRIBUTED = 'Distributed';

export const FOLDER_RETURNED_BY_IRB = 'Returned from IRB';
export const FOLDER_RETURNED_TO_CCO = 'Returned to CCO';

export const PROGRESS_REPORT = 'Progress Report';
export const AMENDMENT_FORM = 'Amendment Form';

// localstorage key
export const KEY_PATHNAME = 'keyPathname';
export const IS_REMEMBER = 'IS_REMEMBER';
export const REMEMBER_EMAIL = 'REMEMBER_EMAIL';
export const REMEMBER_ROLE = 'REMEMBER_ROLE';

// export const STATUS_DRAFT = 'Draft';
// export const STATUS_SUBMITTED = 'Submitted';
// export const STATUS_RE_SUBMITTED = 'Re-submitted';
// export const STATUS_RETURNED = 'Returned';
// export const STATUS_CONFIRM = 'Confirmed';
// export const STATUS_FOR_REVIEW = 'For Review';

export const getUserRoleDisplayFromKey = (userRoleKey) => {
    const result = userRoles.find((item) => {
        return item.key === userRoleKey;
    });

    return result.display;
};

const formTableLookup = {
    instruction: 'Instruction',
    teamMember: 'Team Member Form',
    personalParticulars: 'Personal Particulars',
    outlineOfApplication: 'PART I: OUTLINE OF APPLICATION',
    studyDetails: 'PART IIA: STUDY DETAILS',
    studyDetailsForProspectiveStudy: 'PART IIB: STUDY DETAILS FOR PROSPECTIVE STUDY',
    ethicalImplications: 'PART III: ETHICAL IMPLICATIONS',
    budgetResources: 'PART IV: BUDGET, RESOURCES, INDEMNITY AND INSURANCE',
    clinicalStudyCategorizationFormValid: 'CLINICAL STUDY CATEGORIZATION FORM',
    documentUploadValid: 'Document Upload',
    declarationAndEndorsementValid: 'Declaration And Endorsement',
};

export const formLookup = (key) => {
    return formTableLookup[key];
};

export const getStatusDisplayFromKey = (statusKey, userRoleKey) => {
    const temp = userRoles.find((item) => item.key === userRoleKey);

    if (!temp) {
        console.error('no user role is found');
    }

    const result = temp.folder.find((item) => item.key === statusKey)?.display;

    return result;
};

export const statusLookup = [
    {
        key: DRAFT,
        statusDisplay: 'Draft',
        color: '#cac0cf',
    },
    {
        key: SUBMITTED,
        statusDisplay: 'Submitted',
        color: '#b199bd',
    },
    {
        key: RE_SUBMITTED,
        statusDisplay: 'Re-submitted',
        color: '#a27db3',
    },
    {
        key: RETURNED,
        statusDisplay: 'Returned',
        color: '#895c9e',
    },
    {
        key: REQUEST_FOR_RETURN,
        statusDisplay: 'Requested for return',
        color: '#5a5b5c',
    },
    {
        key: CONFIRMED,
        statusDisplay: 'Confirmed',
        color: '#703e87',
    },
    {
        key: FOR_REVIEW,
        statusDisplay: 'For Review',
        color: '#703e87',
    },
    {
        key: APPROVED,
        statusDisplay: 'Approved',
        color: '#4363d8',
    },
    {
        key: ACKNOWLEDGED,
        statusDisplay: 'Acknowledged',
        color: '#911eb4',
    },
    {
        key: DISAPPROVED,
        statusDisplay: 'Disapproved',
        color: '#f032e6',
    },
    {
        key: WITHDRAWN,
        statusDisplay: 'Withdrawn',
        color: '#48195e',
    },
    {
        key: TERMINATED,
        statusDisplay: 'Terminated',
        color: '#310b42',
    },
    {
        key: COMPLETED,
        statusDisplay: 'Completed',
        color: '#7b0ead',
    },
    {
        key: EXPIRED,
        statusDisplay: 'Expired',
        color: '#9b04e0',
    },
    {
        key: REVIEWED,
        statusDisplay: 'Reviewed',
        color: '#6a81a6',
    },
    {
        key: VERIFIED,
        statusDisplay: 'Verified',
        color: '#7b879c',
    },
    {
        key: DISTRIBUTED,
        statusDisplay: 'Distributed',
        color: '#9A6324',
    },
    {
        key: RETURN_FROM_IRB,
        statusDisplay: 'Returned From IRB',
        color: '#5a5b5c',
    },
    {
        key: NA,
        statusDisplay: 'N/A',
        color: '#000000',
    },
];

export const statusKeyToDisplay = (status) => {
    return statusLookup.find((item) => item.key === status)?.statusDisplay;
};

export const statusBeforeApprove = [
    DRAFT,
    RETURNED,
    RETURN_FROM_IRB,
    SUBMITTED,
    RE_SUBMITTED,
    VERIFIED,
    DISTRIBUTED,
    CONFIRMED,
    REQUEST_FOR_RETURN,
];

export const getApplicantStatusDisplay = (statusId) => {
    return (
        userRoles
            .find((item) => item.key === APPLICANT)
            ?.folder?.find((item) => {
                return item.key === statusId;
            })?.applicantStatusDisplay ?? ''
    );
};

export const userRoles = [
    {
        key: APPLICANT,
        display: 'Applicant',
        // permission: ['draft', 'returned'],
        folder: [
            {
                key: DRAFT,
                display: 'Draft',
                applicantStatusDisplay: 'Draft',
            },
            {
                key: SUBMITTED,
                display: 'Sent',
                applicantStatusDisplay: 'Submitted',
            },
            {
                key: RE_SUBMITTED,
                display: 'Sent',
                applicantStatusDisplay: 'Re-Submitted',
            },
            {
                key: RETURNED,
                display: 'Returned',
                applicantStatusDisplay: 'Returned',
            },
            {
                key: REQUEST_FOR_RETURN,
                display: 'Sent',
                applicantStatusDisplay: 'Requested for Return',
            },
            {
                key: CONFIRMED,
                display: 'Sent',
                applicantStatusDisplay: 'Confirmed',
            },
            {
                key: FOR_REVIEW,
                display: 'Sent',
                applicantStatusDisplay: 'For Review',
            },
            {
                key: APPROVED,
                display: 'Approved',
                applicantStatusDisplay: 'Approved',
            },
            {
                key: ACKNOWLEDGED,
                display: 'Acknowledged',
                applicantStatusDisplay: 'Acknowledged',
            },
            {
                key: DISAPPROVED,
                display: 'Archived',
                applicantStatusDisplay: 'Disapproved',
            },
            {
                key: WITHDRAWN,
                display: 'Archived',
                applicantStatusDisplay: 'Withdrawn',
            },
            {
                key: TERMINATED,
                display: 'Archived',
                applicantStatusDisplay: 'Terminated',
            },
            {
                key: COMPLETED,
                display: 'Completed',
                applicantStatusDisplay: 'Completed',
            },
            {
                key: EXPIRED,
                display: 'Expired',
                applicantStatusDisplay: 'Expired',
            },
            {
                key: REVIEWED,
                display: 'Sent',
                applicantStatusDisplay: 'For Review',
            },
            {
                key: VERIFIED,
                display: 'Sent',
                applicantStatusDisplay: 'Submitted',
            },
            {
                key: DISTRIBUTED,
                display: 'Sent',
                applicantStatusDisplay: 'Submitted',
            },

            {
                key: RETURN_FROM_IRB,
                display: 'Sent',
                applicantStatusDisplay: 'Submitted',
            },
        ],
    },
    {
        key: CCO,
        display: 'CCO',
        // permission: ['submitted'],
        folder: [
            {
                key: DRAFT,
                display: '-',
            },
            {
                key: SUBMITTED,
                display: FOLDER_RECEIVED,
            },
            {
                key: RE_SUBMITTED,
                display: FOLDER_RECEIVED,
            },
            {
                key: RETURNED,
                display: FOLDER_RETURNED,
            },
            {
                key: REQUEST_FOR_RETURN,
                display: FOLDER_RECEIVED,
            },
            {
                key: CONFIRMED,
                display: FOLDER_CONFIRMED,
            },
            {
                key: FOR_REVIEW,
                display: FOLDER_FOR_REVIEW,
            },
            {
                key: APPROVED,
                display: FOLDER_APPROVED,
            },
            {
                key: ACKNOWLEDGED,
                display: FOLDER_ACKNOWLEDGED,
            },
            {
                key: DISAPPROVED,
                display: FOLDER_ARCHIVED,
            },
            {
                key: WITHDRAWN,
                display: FOLDER_ARCHIVED,
            },
            {
                key: TERMINATED,
                display: FOLDER_ARCHIVED,
            },
            {
                key: COMPLETED,
                display: FOLDER_COMPLETED,
            },
            {
                key: EXPIRED,
                display: FOLDER_EXPIRED,
            },
            {
                key: REVIEWED,
                display: FOLDER_REVIEWED,
            },
            {
                key: VERIFIED,
                display: FOLDER_VERIFIED,
            },
            {
                key: DISTRIBUTED,
                display: FOLDER_DISTRIBUTED,
            },
            {
                key: RETURN_FROM_IRB,
                display: 'Returned from IRB',
            },
        ],
    },
    {
        key: CLUSTER_ADMIN,
        display: 'Cluster Administrator',
        // permission: ['submitted'],
        folder: [
            {
                key: DRAFT,
                display: '-',
            },
            {
                key: SUBMITTED,
                display: '-',
            },
            {
                key: RE_SUBMITTED,
                display: FOLDER_RECEIVED,
            },
            {
                key: RETURNED,
                display: FOLDER_RETURNED,
            },
            {
                key: REQUEST_FOR_RETURN,
                display: FOLDER_RECEIVED,
            },
            {
                key: CONFIRMED,
                display: FOLDER_VERIFIED,
            },
            {
                key: FOR_REVIEW,
                display: FOLDER_VERIFIED,
            },
            {
                key: APPROVED,
                display: FOLDER_VERIFIED,
            },
            {
                key: ACKNOWLEDGED,
                display: FOLDER_VERIFIED,
            },
            {
                key: DISAPPROVED,
                display: FOLDER_ARCHIVED,
            },
            {
                key: WITHDRAWN,
                display: FOLDER_ARCHIVED,
            },
            {
                key: TERMINATED,
                display: FOLDER_ARCHIVED,
            },
            {
                key: COMPLETED,
                display: FOLDER_ARCHIVED,
            },
            {
                key: EXPIRED,
                display: FOLDER_ARCHIVED,
            },
            {
                key: REVIEWED,
                display: FOLDER_VERIFIED,
            },
            {
                key: VERIFIED,
                display: FOLDER_VERIFIED,
            },
            {
                key: DISTRIBUTED,
                display: FOLDER_RECEIVED,
            },
            {
                key: RETURN_FROM_IRB,
                display: FOLDER_VERIFIED,
            },
        ],
    },
    {
        key: IRB,
        display: 'Central IRB',
        permission: ['review'],
        folder: [
            {
                key: DRAFT,
                display: '-',
            },
            {
                key: SUBMITTED,
                display: '-',
            },
            {
                key: RE_SUBMITTED,
                display: '-',
            },
            {
                key: RETURNED,
                display: '-',
            },
            {
                key: REQUEST_FOR_RETURN,
                display: '-',
            },
            {
                key: CONFIRMED,
                display: FOLDER_CONFIRMED,
            },
            {
                key: FOR_REVIEW,
                display: FOLDER_FOR_REVIEW,
            },
            {
                key: APPROVED,
                display: FOLDER_APPROVED,
            },
            {
                key: ACKNOWLEDGED,
                display: FOLDER_ACKNOWLEDGED,
            },
            {
                key: DISAPPROVED,
                display: FOLDER_ARCHIVED,
            },
            {
                key: WITHDRAWN,
                display: FOLDER_ARCHIVED,
            },
            {
                key: TERMINATED,
                display: FOLDER_ARCHIVED,
            },
            {
                key: COMPLETED,
                display: FOLDER_COMPLETED,
            },
            {
                key: EXPIRED,
                display: FOLDER_EXPIRED,
            },
            {
                key: REVIEWED,
                display: FOLDER_REVIEWED,
            },
            {
                key: VERIFIED,
                display: '-',
            },
            {
                key: DISTRIBUTED,
                display: '-',
            },
            {
                key: RETURN_FROM_IRB,
                display: 'Returned to CCO',
            },
        ],
    },
    {
        key: SECRETARY,
        display: 'Secretary',
        // permission: ['review'],
        folder: [
            {
                key: DRAFT,
                display: '-',
            },
            {
                key: SUBMITTED,
                display: FOLDER_RECEIVED,
            },
            {
                key: RE_SUBMITTED,
                display: FOLDER_RECEIVED,
            },
            {
                key: RETURNED,
                display: FOLDER_RETURNED,
            },
            {
                key: REQUEST_FOR_RETURN,
                display: FOLDER_RECEIVED,
            },
            {
                key: CONFIRMED,
                display: FOLDER_CONFIRMED,
            },
            {
                key: FOR_REVIEW,
                display: FOLDER_FOR_REVIEW,
            },
            {
                key: APPROVED,
                display: FOLDER_APPROVED,
            },
            {
                key: ACKNOWLEDGED,
                display: FOLDER_ACKNOWLEDGED,
            },
            {
                key: DISAPPROVED,
                display: FOLDER_ARCHIVED,
            },
            {
                key: WITHDRAWN,
                display: FOLDER_ARCHIVED,
            },
            {
                key: TERMINATED,
                display: FOLDER_ARCHIVED,
            },
            {
                key: COMPLETED,
                display: FOLDER_COMPLETED,
            },
            {
                key: EXPIRED,
                display: FOLDER_EXPIRED,
            },
            {
                key: REVIEWED,
                display: FOLDER_REVIEWED,
            },
            {
                key: VERIFIED,
                display: '-',
            },
            {
                key: DISTRIBUTED,
                display: '-',
            },
            {
                key: RETURN_FROM_IRB,
                display: '-',
            },
        ],
    },
    {
        key: REVIEWER,
        display: 'Reviewer',
        isHidden: false,
        // permission: ['review'],
        folder: [
            {
                key: DRAFT,
                display: '-',
            },
            {
                key: SUBMITTED,
                display: '-',
            },
            {
                key: RE_SUBMITTED,
                display: '-',
            },
            {
                key: RETURNED,
                display: '-',
            },
            {
                key: REQUEST_FOR_RETURN,
                display: '-',
            },
            {
                key: CONFIRMED,
                display: '-',
            },
            {
                key: FOR_REVIEW,
                display: FOLDER_FOR_REVIEW,
            },
            {
                key: APPROVED,
                display: '-',
            },
            {
                key: ACKNOWLEDGED,
                display: '-',
            },
            {
                key: DISAPPROVED,
                display: '-',
            },
            {
                key: WITHDRAWN,
                display: '-',
            },
            {
                key: TERMINATED,
                display: '-',
            },
            {
                key: COMPLETED,
                display: '-',
            },
            {
                key: EXPIRED,
                display: '-',
            },
            {
                key: REVIEWED,
                display: '-',
            },
            {
                key: VERIFIED,
                display: '-',
            },
            {
                key: DISTRIBUTED,
                display: '-',
            },
            {
                key: RETURN_FROM_IRB,
                display: '-',
            },
        ],
    },
    {
        key: 'ho-admin',
        display: 'Head Office (HO) Administrator',
        folder: [],
    },
];

export const statusDetailType = {
    ROLE: 0,
    SITE: 1,
    STUDY_INFO: 2,
};

export const statusRole = {
    CCO: 'cco',
    APPLICANT: 'applicant',
    CLUSTER_ADMIN: 'cluster-admin',
    IRB: 'irb',
    REVIEWER: 'reviewer',
    SECRETARY: 'secretary',
    HO_ADMIN: 'ho-admin',
};

export const ROLES = {
    APPLICANT: 'Applicant',
    CCO: 'CCO',
    CLUSTER_ADMIN: 'Cluster Admin',
    IRB: 'IRB',
    SECRETARY: 'Secretary',
    REVIEWER: 'Reviewer',
    HO_ADMIN: 'HO-Admin',
};

export const roleDisplayLookup = {
    [statusRole.APPLICANT]: ROLES.APPLICANT,
    [statusRole.CCO]: ROLES.CCO,
    [statusRole.CLUSTER_ADMIN]: ROLES.CLUSTER_ADMIN,
    [statusRole.IRB]: ROLES.IRB,
    [statusRole.SECRETARY]: ROLES.SECRETARY,
    [statusRole.REVIEWER]: ROLES.REVIEWER,
    [statusRole.HO_ADMIN]: ROLES.HO_ADMIN,
};

export const USERGROUPS = {
    APPLICANT: {
        key: 'APPLICANT',
        label: 'Applicant',
        groups: {},
    },
    CCO: {
        key: 'CCO',
        label: 'CCO',
        groups: {},
    },
    IRB: {
        key: 'IRB',
        label: 'Central IRB',
        groups: {},
    },
    SECRETARY: {
        key: 'SECRETARY',
        label: 'Secretary',
        groups: {},
    },
    HAHO_ADMIN: {
        key: 'HAHO_ADMIN',
        label: 'HAHO Admin',
        groups: {},
    },
    REVIEWER: {
        key: 'REVIEWER',
        label: 'Reviewer',
        groups: {},
    },
    CLUSTER_ADMIN: {
        key: 'CLUSTER_ADMIN',
        label: 'Cluster Admin',
        groups: {
            HKEC: {
                key: 'HKEC',
                label: 'HKEC',
            },
            HKWC: {
                key: 'HKWC',
                label: 'HKWC',
            },
            KCC: {
                key: 'KCC',
                label: 'KCC',
            },
            KEC: {
                key: 'KEC',
                label: 'KEC',
            },
            KWC: {
                key: 'KWC',
                label: 'KWC',
            },
            NTEC: {
                key: 'NTEC',
                label: 'NTEC',
            },
            NTWC: {
                key: 'NTWC',
                label: 'NTWC',
            },
            HKCH: {
                key: 'HKCH',
                label: 'HKCH',
            },
        },
    },
};

export const InformConsentPrincipalInvMatching = {
    0: 0,
    1: 1,
    2: 2,
    3: 3,
    10: 4,
    20: 5,
    30: 6,
    21: 7,
    31: 8,
    32: 9,
    210: 10,
    310: 11,
    320: 12,
    321: 13,
    3210: 14,
};
export const InformConsentPrincipalInvDisplay = {
    0: [0, 4, 5, 6, 10, 11, 12, 14],
    1: [1, 4, 7, 8, 10, 11, 13, 14],
    2: [2, 5, 7, 9, 10, 12, 13, 14],
    3: [3, 6, 8, 9, 11, 12, 13, 14],
};
